import React from "react";
import {Pane} from "evergreen-ui";
import OutputFormsTable from "./OutputFormsTable";

export default function OutputFormsTemplates() {
    return (
        <Pane>
            <OutputFormsTable/>
        </Pane>
    );
}